export default {
  // SPANISH
  welcomeToCompass: "Bienvenido a",
  emailAddress: "Dirección de correo electrónico",
  password: "Clave",
  login: "Acceso",
  continue: "Continuar",
  register: "Registrarse",
  myAccount: "Mi cuenta",
  noAccount: "¿No tiene una cuenta?",
  changePassword: "Cambiar Contraseña",
  modemStatus: {
    outdatedExplanation: "Los datos tienen más de 1 hora de antiguedad",
  },
  myPlansTitle: "Mis Planes",
  viewEdit: "Ver / Editar",
  editKitName: "Editar el Nombre del Kit",
  maximum50Characters: "Máximo 50 caracteres",
  pleaseMaximum50Characters: "Máximo 50 caracteres, por favor",
  starlink: {
    errorChangeKitStatus: "No se pudo cambiar el kit {kitId}",
    errorDeactivateKit: "No se pudo desactivar el kit {kitId}",
    errorSuspendKit: "No se pudo suspender el kit {kitId}",
    errorResumeKit: "No se pudo reanudar el kit {kitId}",
    errorActivateKit: "No se pudo activar el kit {kitId}",
    updateMsg: "El kit {kitId} ha sido actualizado",
    actionButtonSelect: {
      label: "Ningún cambio",
      btnAction: "Aplicar",
      deactivate: "Desactivar",
      suspend: "Suspender",
      resume: "Reanudar",
      activate: "Activar",
    },
    planAllowance: "Cuota del Plan",
    usageLimit: "Límite",
    alertRepeatsInfo: `Si está activa, la alerta se repetirá cada vez que se alcance el límite`,
    alertEmailPlaceholder: "Las alertas se enviarán a los siguientes correos electrónicos",
    emailMax: "Máximo 3 correos electrónicos",
    emailHint: "Añade al menos un correo electrónico y hasta 3 correos electrónicos",
    alertType: "Tipo de Alerta",
    sliderInfo: "Desplace el controlador para definir el límite de la alerta",
    sliderInfoInput: "(o introduzca la cantidad)",
    sliderInfoEmpty_1: "Este tipo de alerta no necesita un límite,",
    sliderInfoEmpty_2: "se activa cuando se alcanza el límite de uso",
    addKit: "Añadir Kit",
    activateKits: "Activar Kits",
    deleteActivationKit: "¿Estás seguro que quierer borrar este Kit de la lista?",
    editKit: "Editar Kit",
    activationForm: {
      detailsTitle: "Detalles",
      optInOutDescription: "Uso de ancho de banda prioritario",
      optInOutDescriptionMobile: "* Para planes móviles, contactar con soporte para usar el ancho de banda prioritario",
      selectKitAndPlan: "Selecciona primero un Kit y un Plan",
      createNewSite: "Crear nuevo sitio",
      kitEditedSuccessfully: "Kit añadido correctamente",
      kitAddedActivation: "Kit añadido a la lista de activación",
      errorValidatingAddress:
        "Error al validar la dirección, por favor intenta de nuevo o selecciona un sitio existente",
      changeSite: "Cambiar sitio",
      addressTitle: "Dirección",
      addressSubtitle: "Especifica la dirección del nuevo sitio",
    },
  },
  activateKits: "Activa tus kits",
  map: {
    map3d: "Mapa 3D",
    map2d: "Mapa 2D",
    legend: {
      ok: "Ok",
      warning: "Advertencia",
      alarm: "Alarma",
      noStatus: "Sin Estatus",
    },
  },
  editServicePlan: {
    optIn: "Optado",
    optOut: "Optar por no participar",
  },
  starlinkModemView: {
    dataUsageCurrentMonth: "Utilización de datos del mes en curso.",
    dataUsageDisclaimer: `El uso de datos no es inmediato y puede retrasarse 24 horas o más. El recuento mostrado es meramente informativo y los usos finales exactos se verán reflejados en la factura mensual.`,
    priority: {
      optedIn: "Prioridad: Opta por paticipar ",
      optedInTooltip:
        "El kit seguirá recibiendo Datos Prioritarios adicionales luego de haber excedido los datos incluídos. Esto incurrirá en cargos adicionales. Visita ‘Manage My Kit’ para cambiar el estado",
      optedOut: "Priority: Opta por no participar ",
      optedOutTooltip:
        "Opta por participar en Datos Prioritarios para mantener prioridad en la red luego de haber excedido los datos incluídos. Esto incurrirá en cargos adicionales. Visita ‘Manage My Kit’ para cambiar el estado",
    },
  },
  noDataForPeriod: "No hay datos que mostrar para este periodo",
  //popup messages
  popupPlanChange: {
    title: "Cambia el plan de tu kit",
    description: "Estas a punto de {action} tu plan actual",
    detailFirstOfMonth: "Tus cambios tomarán efecto inmediatamente.",
    detailNotFirstOfMonth: "Tus cambios tomarán efecto el primer dia de {month}.",
    detailInvalidChange:
      "Cambiar entre planes fixed y mobile plans no está disponible en Compass. Por favor contacta nuestro equipo de soporte para asistencia.",
    disclaimer: "*Tasas adicionales podrían aplicarse",
    success: "Tu plan se actualizó con éxito",
    error: "Tu plan no fue actualizado",
    btn_accept: "Confirmar selección",
    scheduled: "Se programó el cambio de plan a uno inferior",
  },
  profile: "Perfil",
  userPermission: {
    addNewUser: "Agregar nuevo usuario",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Email",
    contactRelationships: "Asignación de Compañías (Opcional)",
    grantedRoles: "Asignación de Roles (Opcional)",
    contactRelationshipsNote:
      "De forma predeterminada, un usuario de una cuenta principal tiene acceso a todas las cuentas infantiles. Si desea limitar el acceso de un usuario a empresas específicas, selecciónelas.",
    grantedRolesNote:
      "De forma predeterminada, un usuario tiene permisos básicos. Si desea otorgar roles adicionales, seleccionelos.",
  },
  pendingPlanChangesMessage: "Se actualizará el plan a uno inferior al inicio del siguiente mes",
  submittedAt: "Agendado: ",
  deletePlanChangeRequestSuccess: "El requerimiento para cambiar plan fue eliminado satisfactoriamente",
  deletePlanChangeRequestError: "No se pudo eliminar el requerimiento de cambio de plan",
  starlinkAlertsReport: {
    title: "Todas las alertas y módems",
    modemsPerPage: "Modems por página",
  },
  changeRequests: "Solicitar Cambio",
  supportGuide: "Guía de Apoyo",
  adminBanners: {
    accountAdminRoleInfo1: "Su Admin maneja su cuenta.",
    accountAdminRoleInfo2: "Comuníquese con su Adminstrador para cambiar sus permisos de usuario.",
    learnMore: "Aprenda más acerca de Permisos de Usuario.",
  },
  plan: "Plan",
  service: "Servicio",
  alert: "Alerta",
  remove: "Remover",
  repeats: "Repite",
  saveChanges: "Guardar Cambios",
  reset: "Restaurar",
  one: "Uno",
  two: "Dos",
  three: "Tres",
  emailInvalid: "Correo electrónico invalido {emails} | Correos electrónicos invalidos: {emails}",
  emailRequired: "Al menos un correo electrónico es necesario",
  errorAlertContactInfo: "Por favor contacta con soporte si este problema persiste",
};
